import React, { useState } from "react";
import LazySvg from "../../utils/LazySvg";
import { StyledAside } from "./AsideStyle";
import { menuItems } from "../../utils/menu";
import { NavLink, useLocation } from "react-router-dom";
import MenuLeft from "../../../../assets/icons/MenuLeft";
import MenuRight from "../../../../assets/icons/MenuRight";
import { useDispatch, useSelector } from "react-redux";
import styled from "styled-components";
import { requestedModalRTLib, UseAuthProvider } from "@bjsdistribution/tms-component-library";
import { supplierMenu } from "../../utils/supplierMenu";
import { useVehicleMaintenanceCounts } from "./useVehicleMaintenance";
import { Skeleton } from "antd";

const Aside = ({ setTheme }) => {
  const userType = JSON.parse(localStorage.getItem("user_type")!);
  const imageUrl = userType?.image_url;
  const dispatch = useDispatch();

  const { toggleMenu } = useSelector((state: any) => state.appMangerUtilitySlice);
  const { isSupplier } = UseAuthProvider();
  const location = useLocation();
  const currentMenu = isSupplier ? supplierMenu : menuItems;

  // Manage manually expanded menus
  const [openMenus, setOpenMenus] = useState<string[]>([]);

  const handleMenuToggle = (menuUrl: string) => {
    setOpenMenus((prev) => (prev.includes(menuUrl) ? prev.filter((url) => url !== menuUrl) : [...prev, menuUrl]));
  };

  const { breakdownData, defectsData, inspectionsData } = useVehicleMaintenanceCounts();

  const getCounts = (data: any) => ({
    first: data?.[0]?.count || 0,
    total: data?.slice(1).reduce((sum: any, item: any) => sum + item.count, 0),
  });

  const breakdownCounts = getCounts(breakdownData);
  const defectCounts = getCounts(defectsData);
  const maintenanceCounts = getCounts(inspectionsData);

  const isActivePath = (path: any) => location.pathname.includes(path);
  const openPopup = () => dispatch(requestedModalRTLib(true));

  const toggleTheme = () => setTheme((prev: any) => (prev === "light" ? "dark" : "light"));

  const renderCount = (parent: any, name: any) => {
    if (parent !== "Maintenance") return null;
    if (name === "Breakdown's") return `${breakdownCounts.total} (${breakdownCounts?.first})`;
    if (name === "Vehicle Defect’s") return `${defectCounts.total} (${defectCounts?.first})`;
    if (name === "Maintenance") return `${maintenanceCounts.total} (${maintenanceCounts?.first})`;
    return null;
  };

  return (
    <StyledAside className={toggleMenu ? "activeMenu" : ""}>
      <div className="LogoPart">
        <a href="/">
          {imageUrl ? (
            <img
              alt="BJSLOGO"
              src={imageUrl}
              style={{
                marginLeft: toggleMenu ? 0 : 10,
                width: toggleMenu ? 50 : 83,
                transition: "0.5s",
              }}
            />
          ) : (
            <Skeleton active paragraph={{ rows: 1 }} style={{ marginLeft: 10, marginTop: 5 }} />
          )}
        </a>
      </div>

      <div className="navigation">
        <nav>
          <ul>
            {currentMenu.map((item, id) => {
              const isActiveByRoute = location.pathname.startsWith(item.url) || item?.subMenu?.some((sub) => location.pathname.startsWith(sub.url));

              const isShown = openMenus.includes(item.url);

              return (
                <li key={id} className={`${isActiveByRoute ? "active" : ""} ${isShown ? "show" : ""}`}>
                  {/* Arrow icon — toggles submenu */}
                  {item.subMenu?.length > 0 && (
                    <i
                      className="arrowIcon"
                      onClick={(e) => {
                        e.stopPropagation();
                        e.preventDefault();
                        handleMenuToggle(item.url);
                      }}
                    >
                      <LazySvg name="arrow" />
                    </i>
                  )}

                  {/* Menu Name / Icon — normal navigation */}
                  <NavLink to={item.url} className={({ isActive }) => (isActive ? "active" : "")}>
                    <div className="flex flex-item-center gap10">
                      <i className="iconWrapper flex-center">
                        <LazySvg name={item.iconName} />
                      </i>
                      <span>{item.name}</span>
                    </div>
                  </NavLink>

                  {/* Submenu — CSS controls visibility via .show or .active */}
                  <ul>
                    {item?.subMenu?.map((suMenu, index) =>
                      suMenu?.disabled ? (
                        <li key={index} onClick={openPopup}>
                          <a href="javascript:void(0)">
                            <div className="flex flex-item-center gap10">
                              <span>{suMenu.name}</span>
                            </div>
                          </a>
                        </li>
                      ) : (
                        <li key={index}>
                          <NavLink
                            end
                            to={suMenu.url}
                            className={({ isActive }) =>
                              (isActivePath("overview") && suMenu.url.endsWith("overview")) ||
                              (isActivePath("maintain") && suMenu.url.endsWith("maintenance")) ||
                              (isActivePath("vehicle-defects") && suMenu.url.endsWith("vehicle-defects")) ||
                              (isActivePath("breakdowns") && suMenu.url.endsWith("breakdowns")) ||
                              (isActivePath("add-vehicle") && suMenu.url.endsWith("add-vehicle")) ||
                              (isActive && !suMenu?.notHighlight)
                                ? "active"
                                : ""
                            }
                          >
                            <Row>
                              <div>{suMenu.name}</div>
                              {renderCount(item.name, suMenu.name) && <CountWrapper>{renderCount(item.name, suMenu.name)}</CountWrapper>}
                            </Row>
                          </NavLink>
                        </li>
                      )
                    )}
                  </ul>

                  <div className="arrow">
                    <MenuLeft />
                    <MenuRight />
                  </div>
                </li>
              );
            })}
          </ul>
        </nav>
      </div>

      <Setting onClick={toggleTheme} />
    </StyledAside>
  );
};

const Row = styled.div`
  display: flex;
  padding-left: 8px;
  justify-content: space-between;
  align-items: center;
`;

const CountWrapper = styled.div`
  display: flex;
  width: fit-content;
  padding: 4px 8px;
  justify-content: center;
  align-items: center;
  border-radius: 20px;
  background: #1483de;
  color: #fff;
  font-size: 13px;
  font-family: Inter;
`;

const Setting = styled.div`
  position: absolute;
  bottom: 25px;
  font-size: 16px;
  color: #fff;
  padding-left: 20px;
  display: flex;
  gap: 10px;
  cursor: pointer;
`;

export default Aside;
